import { Typography, WithStyles, withStyles } from "@material-ui/core";
import React from "react";
import Accordion from "@material-ui/core/Accordion/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import AccordionDetails from "@material-ui/core/AccordionDetails/AccordionDetails";
import { IFAQItem } from "./FaqQuestions";
import { styles } from "./FaqView.styles";

interface IFaqItemProps extends WithStyles<typeof styles> {
    item: IFAQItem;
}

 const FaqItemPure: React.FunctionComponent<IFaqItemProps> = ({ classes, item }) => {
    return (
        <Accordion >
            <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header">
                <Typography variant="h4">{item?.q}</Typography>
            </AccordionSummary>
            <AccordionDetails className={classes.accordionDetails}>
                <Typography component={"div"} variant="body1">{item?.a}</Typography>
            </AccordionDetails>
        </Accordion>
    );
};

export const FaqItem = withStyles(styles)(FaqItemPure);
